import React, { useState } from 'react';
import { ArrowRight, CheckCircle } from 'lucide-react';
import axios from 'axios';
import './MailingListSection.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const MailingListSection = () => {
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [status, setStatus] = useState({ loading: false, success: false, error: null });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!consent) {
      setStatus({ loading: false, success: false, error: 'Por favor, aceite a Política de Privacidade.' });
      return;
    }

    setStatus({ loading: true, success: false, error: null });
    
    try {
      await axios.post(`${API}/public/newsletter/subscribe`, { email });
      setStatus({ loading: false, success: true, error: null });
      setEmail('');
      setConsent(false);
      
      // Reset success message after 5 seconds
      setTimeout(() => {
        setStatus({ loading: false, success: false, error: null });
      }, 5000);
    } catch (error) {
      console.error('Erro ao subscrever:', error);
      setStatus({ 
        loading: false, 
        success: false, 
        error: error.response?.data?.detail || 'Erro ao processar subscrição. Tente novamente.' 
      });
    }
  };

  return (
    <section className="newsletter-velcome" data-testid="mailing-list-section">
      <div className="newsletter-container-velcome">
        <div className="newsletter-content-velcome">
          <span className="newsletter-label-velcome">NEWSLETTER</span>
          <h2 className="newsletter-title-velcome">Mantenha-se Informado</h2>
          <p className="newsletter-description-velcome">
            Receba as últimas notícias, eventos e informações sobre saúde mental diretamente no seu email.
          </p>
        </div>
        
        <div className="newsletter-form-wrapper-velcome">
          {status.success ? (
            <div className="newsletter-success-velcome">
              <CheckCircle size={24} />
              <span>Subscrição confirmada! Obrigado por se juntar a nós.</span>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="newsletter-form-velcome" data-testid="newsletter-form">
              <div className="newsletter-input-group-velcome">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="O seu endereço de e-mail"
                  required
                  data-testid="newsletter-email-input"
                />
                <button 
                  type="submit" 
                  disabled={status.loading}
                  data-testid="newsletter-submit-btn"
                >
                  {status.loading ? 'A enviar...' : (
                    <>
                      SUBSCREVER
                      <ArrowRight size={18} />
                    </>
                  )}
                </button>
              </div>
              
              <div className="newsletter-consent-velcome">
                <input
                  type="checkbox"
                  id="newsletter-consent"
                  checked={consent}
                  onChange={(e) => setConsent(e.target.checked)}
                  required
                />
                <label htmlFor="newsletter-consent">
                  Aceito receber comunicações da AASPS conforme a <a href="/politica-privacidade">Política de Privacidade</a>
                </label>
              </div>
              
              {status.error && (
                <div className="newsletter-error-velcome">{status.error}</div>
              )}
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default MailingListSection;
